<template>
  <div class="common-page order-management">
    <div class="top-box">
      <div class="search-form-box">
        <el-row :gutter="30">
          <el-form inline>
            <el-col :span="5" v-if="companyType === '1'">
              <el-form-item label="分公司:">
                <el-select style="width: 100%" v-model="searchForm.belongCompanyId" placeholder="请选择">
                  <el-option
                    v-for="item in belongCompanyData"
                    :key="item.companyId"
                    :label="item.companyName"
                    :value="item.companyId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="充值时间:">
                <custom-date-range
                  :start-date="searchForm.startTime"
                  :end-date="searchForm.endTime"
                  @update:startDate="(val) => (searchForm.startTime = val)"
                  @update:endDate="(val) => (searchForm.endTime = val)"></custom-date-range>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="充值类型:" prop="rechargeType">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.rechargeType"
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in rechargeTypeData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="充值单号:" prop="rechargeNo">
                <el-input
                  v-model="searchForm.rechargeNo"
                  clearable
                  autocomplete="off"
                  placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="">
                <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
                <el-button type="default" round icon="el-icon-refresh" @click="handleReset(['belongCompanyId'])"></el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </div>

    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange">

        <template v-slot:rechargeType="{ row }">
          <span class="common-status" v-if="row.rechargeType === 1">代理商充值</span>
          <span class="common-status" v-if="row.rechargeType === 2">服务商充值</span>
          <span class="common-status" v-if="row.rechargeType === 3">司机充值</span>
        </template>
      </custom-table>
    </div>
  </div>
</template>

<script>
import {numberToThousand} from "@/utils/tool"
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomDateRange from "@/components/CustomDateRange.vue";
import addOrEdit from "./addOrEdit.vue";
import { getPage, getOwnerOverview } from "./api";
import tableMixin from "@/mixin/tableMixin";

import { getSelectAgent } from "@/views/SystemManagement/AgentManagement/api";
export default {
  name: "RechargeRecord",
  mixins: [tableMixin],
  components: {
    OperateBox,
    CustomTable,
    CustomDateRange,
    addOrEdit,
  },
  data() {
    return {
      getTableMethod: getPage,
      searchForm: {
        "belongCompanyId": "",
        "endTime": "",
        "rechargeNo": "",
        "rechargeType": "",
        "startTime": ""
      },
      isImmediatelyGetData: true,
      haveBelongCompany: true,
      rechargeTypeData: [
        {
          label: "代理商充值",
          value: 1,
        },
        {
          label: "服务商充值",
          value: 2
        },
        {
          label: "司机充值",
          value: 3,
        }
      ],
      tableColumn: [
        {
          label: "充值单号",
          prop: "rechargeNo",
          align: "left",
          show: true,
        },
        {
          label: "充值金额",
          prop: "rechargeAmount",
          align: "left",
          show: true,
        },
        {
          label: "充值对象",
          prop: "targetName",
          align: "left",
          show: true,
        },
        {
          label: "充值类型",
          prop: "rechargeType",
          align: "left",
          scopeStatus: true,
          show: true,
        },
        {
          label: "充值时间",
          prop: "rechargeTime",
          align: "left",
          show: true,
        },
        {
          label: "充值人",
          prop: "rechargeUserName",
          align: "left",
          show: true,
        },
        {
          label: "备注",
          prop: "remark",
          align: "left",
          show: true,
        },
      ],
      statisticsImage1: require("@/assets/imgs/huozhuzongliang.png"),
      statisticsImage2: require("@/assets/imgs/youxiaohuozhu.png"),
      statisticsImage3: require("@/assets/imgs/xiadanbishu.png"),
      statisticsImage4: require("@/assets/imgs/dingdanwancheng.png"),
      statisticsImage5: require("@/assets/imgs/leijijine.png"),
    };
  },
  created() {
  },
  mounted() {},
  methods: {
    numberToThousand,
  },
};
</script>
<style lang="scss" scoped>
.order-management {
  .custom-table-box{
    padding-top: 0;
  }
  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }
  .custom-tip {
    font-size: 0.16rem;
    padding: 0.16rem 0.2rem;
    background: rgba(18, 105, 255, 0.05);
    box-sizing: border-box;
    margin: 0 0.16rem;
    border-radius: 0.03rem;
    border: 0.01rem dashed #1269ff;
    .price-label {
      padding: 0 0.04rem 0 0.1rem;
    }
  }
  .drop-image {
    width: 0.24rem;
    height: 0.24rem;
  }

  .owner-requirement {
    background-color: rgba(217, 236, 255, 0.5);
    color: #1269ff;
    padding: 0.05rem;
    border-radius: 0.06rem;
  }

  .mileage {
    position: relative;
    padding: 0 0.05rem 0.06rem;
  }

  .mileage::after {
    content: "→";
    position: absolute;
    left: 0;
    bottom: -0.06rem;
    text-align: center;
    width: 100%;
  }
}
</style>
